import type { ClassListSnapshot } from "../api/landingClass.types";

const STORAGE_PREFIX = "landing_class_snapshot_";

function storageKey(levelId: string, classId: string): string {
  return `${STORAGE_PREFIX}${levelId}_${classId}`;
}

export function saveClassDetailSnapshot(
  levelId: string,
  classId: string,
  snapshot: ClassListSnapshot
): void {
  try {
    sessionStorage.setItem(storageKey(levelId, classId), JSON.stringify(snapshot));
  } catch {
    // Ignore quota / private mode errors
  }
}

export function loadClassDetailSnapshot(
  levelId: string,
  classId: string
): ClassListSnapshot | null {
  try {
    const raw = sessionStorage.getItem(storageKey(levelId, classId));
    if (!raw) return null;
    return JSON.parse(raw) as ClassListSnapshot;
  } catch {
    return null;
  }
}
